module.exports = __webpack_public_path__ + "static/media/clock_icon.d3f11026.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/clock_icon.svg
// module id = 323
// module chunks = 21